export enum GroupAuthority {
  READ = 'READ',
  DELETE = 'DELETE',
}
  